import { fromPairs } from 'lodash-es'
import { State } from './state'

export const brandsForIds = (state: State) => (ids: number[]) =>
  state.brandsById && fromPairs(ids.map((id) => [id, state.brandsById![id]]))
